export function PatternValidator() {
    var obj = {
        isValidEmail: isValidEmail,
        isValidPhone: isValidPhone,
        isValidAddress: isValidAddress,
        isValidCity: isValidCity,
        isValidState: isValidState,
        isValidZipCode: isValidZipCode,
        isValidPostalCode: isValidPostalCode,
        isValidZipOrPostalCode: isValidZipOrPostalCode,
        isValidCommunityName: isValidCommunityName,
        isXSS: isXSS,
        isOnlySpaces: isOnlySpaces,
        isValidVisitDate : isValidVisitDate,
        isValidFirstName : isValidFirstName, // alpha characters + space
        isValidMiddleName: isValidMiddleName, // same as first name
        isValidLastName : isValidLastName // alpha characters + space + dash
    };
    return obj;

    function isValidEmail(email) 
    {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    }

    function isValidPhone(phone) {
        // Changed area code from [0-9] to [2-9] since area code cannot start with a 0 or 1
        var phoneRe = /^[(]{0,1}[2-9]{1}[0-9]{2}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
        var digits = phone.replace(/\D/g, "");
        return phoneRe.test(digits);
    }

    // Zip Code is for 5 or 9 digit U.S. Zip Codes
    function isValidZipCode(zipCode) {
        var zipCodeRe = /^\d{5}(?:-\d{4})?$/;
        return zipCodeRe.test(zipCode);
    }

    // Postal Code is for Canadian Postal Codes
    function isValidPostalCode(postalCode) {
        var postalCodeRe = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
        return postalCodeRe.test(postalCode);
    }

    function isValidZipOrPostalCode(code) {
        return isValidZipCode(code) || isValidPostalCode(code);
    }

    //
    // Validate for cross site scripting (XSS)
    //
    function isXSS(txt) {
        let pattern = /[<>!()/“"\]}=\[{&]+/; // checks for < > ! ( ) “ " ] } = { &
        return pattern.test(txt);
    }

    function isOnlySpaces(txt) {
        // Use a regular expression to check if the txt contains only spaces
        return /^\s*$/.test(txt);
      }
    
    // Visit Date is format MM/DD/YYYY or MM-DD-YYYY
    function isValidVisitDate(visitDate) {
        var visitDateRe = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        var visitDateRe2 = /^(0[1-9]|1[0-2])\-(0[1-9]|1\d|2\d|3[01])\-(19|20)\d{2}$/;
        return visitDateRe.test(visitDate) || visitDateRe2.test(visitDate);
    }

    function isValidFirstName(txt) {
        var pattern = /^[a-zA-Z\s]+$/;  // alpha + space
        return pattern.test(txt) && !isXSS(txt);
    }

    function isValidMiddleName(txt) {
        var pattern = /^[a-zA-Z\s]+$/;  // alpha + space (same as first name)
        return pattern.test(txt) && !isXSS(txt);
    }

    function isValidLastName(txt) {
        var pattern = /^[a-zA-Z\s\-]+$/; // alpha + space + hyphen
        return pattern.test(txt) && !isXSS(txt);
    }

    function isValidAddress(txt) {
        var pattern = /^[a-zA-Z0-9\s,\'\-\.]+$/; // alpha + space + apostrophe + hyphen + period
        return pattern.test(txt) && !isXSS(txt);
    }

    function isValidCity(txt) {
        var pattern = /^[a-zA-Z\s]+$/; // alpha + space
        return pattern.test(txt) && !isXSS(txt);
    }

    function isValidState(txt) {
        var pattern = /^[a-zA-Z\s]+$/; // alpha + space
        return pattern.test(txt) && (!isXSS(txt));
    }

    function isValidCommunityName(txt) {
        var pattern = /^[a-zA-Z0-9\s&\']+$/; // alpha numeric + space +  ampersand + apostrophe
        return pattern.test(txt) && (!isXSS(txt)  || txt.indexOf('&') > -1);
    }
}
